const Aviation = () => {
    return (
    <div>
      <div className="">
        <img src="/ExpressBanner/banner-5.jpg" width="100%"/>
      </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
    
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
              Aviation
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              TCS Aviation division specialises in delivering customised air freight solutions 
              for freight forwarders, pharmaceutical industry, charities and relief organisations, 
              government departments, airlines, general sales agents, oil and automotive industries 
              and brokers. TCS Aviation, with its dedicated air fleet and international offices in 
              Pakistan, UAE and the UK, assures that all the air freight and charter requirement are fulfilled. 
            </p>
              
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>
    </div>

    )
};
export default Aviation;